import {jsx as _jsx} from "react/jsx-runtime";





const LightIsland = (props) => {
  const {children} = props
  return _jsx('div', { className: "light-island contents" , children: children})
}

export default LightIsland
